module.exports = __webpack_public_path__ + "img/img5.54a6f98f.png";